const groupPrefix = 'contact-form'

export const apiContactForm = {
	sendContactForm: async (formData: IContactFormRequestModel) => {
		const { data } = await apiCommon<IContactFormRequest>(`${groupPrefix}`, {
			method: 'POST',
			body: ContactFormToJSON(formData),
		})
		return data
	},
}
